/* terrea-subscribe.js */

(function () {
  var API  = 'https://terrea-rewards-1.onrender.com';
  var SHOP = 'hrwxgq-ka.myshopify.com';
  var THIRTY_MIN = 30 * 60 * 1000;

  function getCID() {
    return (window.TERREA_CUSTOMER_ID || '').toString();
  }

  function findLink(cb) {
    var container = cb.closest('.product-description') || cb.closest('li') || cb.closest('.cart-item') || cb.closest('td');
    if (container) {
      var link = container.querySelector('.tc-sub-link');
      if (link) return link;
    }
    var label = cb.closest('label');
    if (label) {
      var sib = label.parentElement ? label.parentElement.nextElementSibling : null;
      if (sib && sib.classList && sib.classList.contains('tc-sub-link')) return sib;
      if (label.nextElementSibling && label.nextElementSibling.classList &&
          label.nextElementSibling.classList.contains('tc-sub-link')) {
        return label.nextElementSibling;
      }
    }
    return null;
  }

  function getCartProducts() {
    return fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (cart && cart.items) {
          return cart.items.map(function (it) {
            return { title: it.product_title || it.title || '', handle: it.handle || '', qty: it.quantity || 1 };
          });
        }
        return [];
      })
      .catch(function () { return []; });
  }

  function redeemAndCheckout(CID, cartTotal, pts, cartProducts, onError) {
    return fetch(API + '/api/redeem', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        customer_id:   CID,
        shop:          SHOP,
        order_total:   cartTotal,
        redeem_amount: pts,
        products:      cartProducts
      })
    })
    .then(function (r) { return r.json(); })
    .then(function (data) {
      if (data.success && data.code) {
        window.location.href = '/discount/' + encodeURIComponent(data.code) + '?redirect=/checkout';
      } else {
        if (onError) onError(data.error || 'Error — try again');
      }
    })
    .catch(function (err) {
      console.error('[Terrea] redeem error', err);
      if (onError) onError('Error — try again');
    });
  }

  var lastSyncTime = 0;
  function syncChecks(force) {
    var CID = getCID();
    if (!CID) return;

    // ← Проверяем истёкшие подписки (30 минут)
    Object.keys(localStorage).forEach(function(key) {
      if (!key.startsWith('tc_sub_time_')) return;
      var ts = parseInt(localStorage.getItem(key)) || 0;
      if (Date.now() - ts > THIRTY_MIN) {
        var pid = key.replace('tc_sub_time_', '');
        localStorage.removeItem(key);
        fetch(API + '/api/subscription/cart', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            customer_id: CID,
            shop:        SHOP,
            product_id:  pid,
            action:      'remove'
          })
        }).catch(function(){});
        document.querySelectorAll('.tc-subscribe-cb').forEach(function(cb) {
          if (String(cb.dataset.productId) === String(pid)) {
            cb.checked = false;
            var link = findLink(cb);
            if (link) link.style.display = 'none';
          }
        });
        console.log('[Terrea] ⏰ Pending subscription expired for product', pid);
      }
    });

    var now = Date.now();
    if (!force && (now - lastSyncTime) < 1000) return;
    lastSyncTime = now;

    fetch(API + '/api/subscription?customer_id=' + CID + '&shop=' + SHOP)
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var subscribed = d.subscribedProducts || [];
        var details = d.productDetails || d.allProducts || [];
        var qtyMap = {};
        details.forEach(function (p) {
          if (p && p.id != null) qtyMap[String(p.id)] = parseInt(p.quantity) || 1;
        });
        document.querySelectorAll('.mini-cart .tc-subscribe-cb').forEach(function (cb) {
          var pid = String(cb.dataset.productId);
          if (subscribed.indexOf(pid) !== -1) {
            cb.checked = true;
            localStorage.removeItem('tc_sub_time_' + pid); // ← очищаем таймер если оплачено
            var link = findLink(cb);
            if (link) link.style.display = 'block';
            var container = cb.closest('.product-description') || cb.closest('li') || cb.closest('div');
            var qtyInput = container ? container.querySelector('.tc-sub-qty') : null;
            if (qtyInput && qtyMap[pid]) qtyInput.value = qtyMap[pid];
          }
        });
      })
      .catch(function (err) { console.warn('[Terrea] sync failed', err); });
  }

  document.addEventListener('click', function (e) {
    var cb = e.target;
    if (!cb.classList || !cb.classList.contains('tc-subscribe-cb')) return;
    if (!cb.closest('.mini-cart')) return;

    var CID = getCID();
    if (!CID) {
      e.preventDefault();
      alert('Please log in to subscribe.');
      cb.checked = false;
      return;
    }

    e.stopPropagation();
    e.stopImmediatePropagation();

    var willBeChecked = cb.checked;
    var qtyContainer = cb.closest('.product-description') || cb.closest('li') || cb.closest('.cart-item') || cb.closest('td') || cb.closest('div');
    var qtyInput = qtyContainer ? qtyContainer.querySelector('.tc-sub-qty') : null;
    var quantity = qtyInput ? (parseInt(qtyInput.value) || 1) : 1;

    // ← Сохраняем время подписки
    if (willBeChecked) {
      localStorage.setItem('tc_sub_time_' + cb.dataset.productId, String(Date.now()));
    } else {
      localStorage.removeItem('tc_sub_time_' + cb.dataset.productId);
    }

    cb.disabled = true;
    var act = willBeChecked ? 'add' : 'remove';

    fetch(API + '/api/subscription/cart', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        customer_id:   CID,
        shop:          SHOP,
        product_id:    cb.dataset.productId,
        product_title: cb.dataset.productTitle,
        product_image: cb.dataset.productImage,
        price:         parseFloat(cb.dataset.price),
        quantity:      quantity,
        action:        act
      })
    })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        cb.disabled = false;
        if (!d.success) {
          cb.checked = !willBeChecked;
          // Откатываем таймер
          if (willBeChecked) {
            localStorage.removeItem('tc_sub_time_' + cb.dataset.productId);
          }
          alert('Subscription error: ' + (d.error || d.message || 'unknown'));
          return;
        }
        var link = findLink(cb);
        if (link) link.style.display = cb.checked ? 'block' : 'none';
      })
      .catch(function (err) {
        cb.checked = !willBeChecked;
        localStorage.removeItem('tc_sub_time_' + cb.dataset.productId);
        cb.disabled = false;
      });
  }, true);

  document.addEventListener('change', function (e) {
    var el = e.target;

    if (el.classList && el.classList.contains('tc-sub-qty') && el.closest('.mini-cart')) {
      e.stopPropagation();
      e.stopImmediatePropagation();
      var container = el.closest('.product-description') || el.closest('li') || el.closest('div');
      var cb = container ? container.querySelector('.tc-subscribe-cb') : null;
      if (cb && cb.checked) {
        var CID = getCID();
        if (!CID) return;
        var quantity = parseInt(el.value) || 1;
        fetch(API + '/api/subscription/cart', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            customer_id:   CID,
            shop:          SHOP,
            product_id:    cb.dataset.productId,
            product_title: cb.dataset.productTitle,
            product_image: cb.dataset.productImage,
            price:         parseFloat(cb.dataset.price),
            quantity:      quantity,
            action:        'add'
          })
        })
        .then(function (r) { return r.json(); })
        .then(function (d) { console.log('[Terrea] qty updated to', quantity, d); })
        .catch(function (err) { console.error('[Terrea] qty update error', err); });
      }
      return;
    }

    if (!el.classList || !el.classList.contains('tc-subscribe-cb')) return;
    if (!el.closest('.mini-cart')) return;
    e.stopPropagation();
    e.stopImmediatePropagation();
  }, true);

  var syncTimer = null;
  var isSyncing = false;
  var lastSyncCount = -1;

  function debouncedSync() {
    if (isSyncing) return;
    var checkboxes = document.querySelectorAll('.mini-cart .tc-subscribe-cb');
    if (checkboxes.length === 0) return;
    if (checkboxes.length === lastSyncCount) return;
    if (syncTimer) clearTimeout(syncTimer);
    syncTimer = setTimeout(function () {
      lastSyncCount = document.querySelectorAll('.mini-cart .tc-subscribe-cb').length;
      isSyncing = true;
      syncChecks();
      initWallet();
      setTimeout(function () { isSyncing = false; }, 500);
    }, 300);
  }

  var walletTimer = null;
  function checkWallet() {
    if (walletTimer) clearTimeout(walletTimer);
    walletTimer = setTimeout(function () {
      var box = document.querySelector('.mini-cart #tc-wallet-box');
      if (box) initWallet();
      var pageBox = document.querySelector('#tc-wallet-box-page');
      if (pageBox) initWalletPage();
      if (document.querySelector('.mini-cart .tc-subscribe-cb')) syncChecks();
    }, 350);
  }

  var observer = new MutationObserver(function (mutations) {
    var relevant = false;
    for (var i = 0; i < mutations.length; i++) {
      if (mutations[i].type === 'childList' && mutations[i].addedNodes.length > 0) { relevant = true; break; }
    }
    if (relevant) { debouncedSync(); checkWallet(); }
  });
  observer.observe(document.body, { childList: true, subtree: true });

  if (document.readyState !== 'loading') {
    setTimeout(function () { syncChecks(); checkWallet(); initWalletPage(); }, 100);
  } else {
    document.addEventListener('DOMContentLoaded', function () {
      setTimeout(function () { syncChecks(); checkWallet(); initWalletPage(); }, 100);
    });
  }

  function updateSubtotal(cartTotal, redeem) {
    var el = document.querySelector('.mini-cart #mini-cart-subtotal');
    if (!el) return;
    if (!el.dataset.tcOriginal) el.dataset.tcOriginal = el.textContent.trim();
    var orig = el.dataset.tcOriginal;
    if (redeem > 0) {
      var newTotal = (cartTotal - redeem).toFixed(2);
      el.innerHTML = '<span style="text-decoration:line-through;opacity:0.45;font-weight:400;margin-right:6px;">' + orig + '</span>£' + newTotal;
    } else {
      el.textContent = orig;
    }
  }

  function updatePageSubtotal(cartTotal, redeem) {
    var el = document.querySelector('#tcp-cart-subtotal');
    if (!el) return;
    if (!el.dataset.tcOriginal) el.dataset.tcOriginal = el.textContent.trim();
    var orig = el.dataset.tcOriginal;
    if (redeem > 0) {
      var newTotal = (cartTotal - redeem).toFixed(2);
      el.innerHTML = '<span style="text-decoration:line-through;opacity:0.45;font-weight:400;margin-right:6px;">' + orig + '</span>£' + newTotal;
    } else {
      el.textContent = orig;
    }
  }

  // ============ КОШЕЛЁК В МИНИ-КОРЗИНЕ ============
  function initWallet() {
    var box = document.querySelector('.mini-cart #tc-wallet-box');
    if (!box) return;
    var CID = getCID();
    if (!CID) return;

    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        var codes = cart.discount_codes || [];
        var hasWallet = codes.some(function(d) {
          return d.code && d.code.startsWith('WALLET-');
        });
        if (hasWallet) {
          fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ discount: '' })
          })
          .then(function(r) { return r.json(); })
          .then(function(updatedCart) {
            var realPence = updatedCart.total_price || 0;
            box.dataset.cartTotal   = String(realPence);
            box.dataset.tcInitTotal = '';
            runWallet(box, CID);
          })
          .catch(function() { runWallet(box, CID); });
        } else {
          runWallet(box, CID);
        }
      })
      .catch(function() { runWallet(box, CID); });
  }

  function runWallet(box, CID) {
    var cartTotalPence = parseInt(box.dataset.cartTotal) || 0;
    var cartTotal = cartTotalPence / 100;

    if (box.dataset.tcInitTotal === String(cartTotalPence)) return;
    box.dataset.tcInitTotal = String(cartTotalPence);

    fetch(API + '/api/balance?customer_id=' + CID + '&shop=' + SHOP)
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var balance = d.balance || 0;
        if (balance <= 0) { box.style.display = 'none'; return; }

        var maxRedeem = Math.min(balance, Math.floor(cartTotal * 0.5));
        if (maxRedeem <= 0) { box.style.display = 'none'; return; }

        box.style.display = 'block';
        var slider   = box.querySelector('#tc-wallet-slider');
        var ptsEl    = box.querySelector('#tc-wallet-pts');
        var offEl    = box.querySelector('#tc-wallet-off');
        var finalEl  = box.querySelector('#tc-wallet-final');
        var applyBtn = box.querySelector('#tc-wallet-apply');
        var msg      = box.querySelector('#tc-wallet-msg');

        box.querySelector('#tc-wallet-balance').textContent = balance;
        box.querySelector('#tc-wallet-max').textContent = maxRedeem;
        slider.max   = maxRedeem;
        slider.value = 0;
        ptsEl.textContent = 0;
        offEl.textContent = 0;
        if (offEl && offEl.parentElement) offEl.parentElement.style.visibility = 'hidden';
        if (finalEl) finalEl.textContent = cartTotal.toFixed(2);
        applyBtn.disabled = true;
        updateSubtotal(cartTotal, 0);

        if (box.dataset.tcBound !== '1') {
          box.dataset.tcBound = '1';

          slider.addEventListener('input', function () {
            var v = parseInt(slider.value) || 0;
            ptsEl.textContent = v;
            offEl.textContent = v;
            if (offEl && offEl.parentElement) {
              offEl.parentElement.style.visibility = v > 0 ? 'visible' : 'hidden';
            }
            var ct = (parseInt(box.dataset.cartTotal) || 0) / 100;
            if (finalEl) finalEl.textContent = (ct - v).toFixed(2);
            applyBtn.disabled = v <= 0;
            updateSubtotal(ct, v);
          });

          applyBtn.addEventListener('click', function () {
            var pts = parseInt(slider.value) || 0;
            if (pts <= 0) return;
            applyBtn.disabled = true;
            applyBtn.textContent = 'Applying...';
            if (msg) msg.textContent = '';
            getCartProducts().then(function (cartProducts) {
              redeemAndCheckout(CID, cartTotal, pts, cartProducts, function (err) {
                if (msg) msg.textContent = err;
                applyBtn.disabled = false;
                applyBtn.textContent = 'Apply Balance';
              });
            });
          });
        }
      })
      .catch(function (err) { console.warn('[Terrea] balance load failed', err); });
  }

  // ============ КОШЕЛЁК НА ПОЛНОЙ СТРАНИЦЕ КОРЗИНЫ ============
  function initWalletPage() {
    var box = document.querySelector('#tc-wallet-box-page');
    if (!box) return;
    var CID = getCID();
    if (!CID) return;

    var cartTotalPence = parseInt(box.dataset.cartTotal) || 0;
    var cartTotal = cartTotalPence / 100;

    if (box.dataset.tcInitTotal === String(cartTotalPence)) return;
    box.dataset.tcInitTotal = String(cartTotalPence);

    fetch(API + '/api/balance?customer_id=' + CID + '&shop=' + SHOP)
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var balance = d.balance || 0;
        if (balance <= 0) { box.style.display = 'none'; return; }

        var maxRedeem = Math.min(balance, Math.floor(cartTotal * 0.5));
        if (maxRedeem <= 0) { box.style.display = 'none'; return; }

        box.style.display = 'block';
        var slider   = box.querySelector('#tcp-wallet-slider');
        var ptsEl    = box.querySelector('#tcp-wallet-pts');
        var offEl    = box.querySelector('#tcp-wallet-off');
        var finalEl  = box.querySelector('#tcp-wallet-final');
        var applyBtn = box.querySelector('#tcp-wallet-apply');
        var msg      = box.querySelector('#tcp-wallet-msg');

        box.querySelector('#tcp-wallet-balance').textContent = balance;
        box.querySelector('#tcp-wallet-max').textContent = maxRedeem;
        slider.max   = maxRedeem;
        slider.value = 0;
        ptsEl.textContent = 0;
        offEl.textContent = 0;
        if (offEl && offEl.parentElement) offEl.parentElement.style.visibility = 'hidden';
        if (finalEl) finalEl.textContent = cartTotal.toFixed(2);
        applyBtn.disabled = true;
        updatePageSubtotal(cartTotal, 0);

        if (box.dataset.tcBound !== '1') {
          box.dataset.tcBound = '1';

          slider.addEventListener('input', function () {
            var v = parseInt(slider.value) || 0;
            ptsEl.textContent = v;
            offEl.textContent = v;
            if (offEl && offEl.parentElement) {
              offEl.parentElement.style.visibility = v > 0 ? 'visible' : 'hidden';
            }
            var ct = (parseInt(box.dataset.cartTotal) || 0) / 100;
            if (finalEl) finalEl.textContent = (ct - v).toFixed(2);
            applyBtn.disabled = v <= 0;
            updatePageSubtotal(ct, v);
          });

          applyBtn.addEventListener('click', function () {
            var pts = parseInt(slider.value) || 0;
            if (pts <= 0) return;
            applyBtn.disabled = true;
            applyBtn.textContent = 'Applying...';
            if (msg) msg.textContent = '';
            getCartProducts().then(function (cartProducts) {
              redeemAndCheckout(CID, cartTotal, pts, cartProducts, function (err) {
                if (msg) msg.textContent = err;
                applyBtn.disabled = false;
                applyBtn.textContent = 'Apply Balance';
              });
            });
          });

          var pageCheckoutBtn = document.querySelector('button[name="checkout"]:not(.mini-cart button)');
          if (!pageCheckoutBtn) pageCheckoutBtn = document.querySelector('.cart__checkout-button');
          if (pageCheckoutBtn && !pageCheckoutBtn.dataset.tcCheckoutBound) {
            pageCheckoutBtn.dataset.tcCheckoutBound = '1';
            pageCheckoutBtn.addEventListener('click', function (e) {
              var pts = parseInt(slider.value) || 0;
              if (pts <= 0) return;
              e.preventDefault();
              e.stopPropagation();
              pageCheckoutBtn.disabled = true;
              pageCheckoutBtn.textContent = 'Applying wallet...';
              getCartProducts().then(function (cartProducts) {
                redeemAndCheckout(CID, cartTotal, pts, cartProducts, function () {
                  pageCheckoutBtn.disabled = false;
                  pageCheckoutBtn.textContent = 'Check out';
                  window.location.href = '/checkout';
                });
              });
            });
          }
        }
      })
      .catch(function (err) { console.warn('[Terrea] page balance load failed', err); });
  }

  console.log('[Terrea] subscribe.js loaded globally');
})();